import { config } from '@grafana/runtime';

var AzureCloud = /* @__PURE__ */ ((AzureCloud2) => {
  AzureCloud2["Public"] = "AzureCloud";
  AzureCloud2["China"] = "AzureChinaCloud";
  AzureCloud2["USGovernment"] = "AzureUSGovernment";
  AzureCloud2["None"] = "";
  return AzureCloud2;
})(AzureCloud || {});
const predefinedClouds = [
  { name: "AzureCloud", displayName: "Azure" },
  { name: "AzureChinaCloud", displayName: "Azure China" },
  { name: "AzureUSGovernment", displayName: "Azure US Government" }
];
function getAzureClouds() {
  const settingsEx = config.azure;
  if (Array.isArray(settingsEx.clouds) && settingsEx.clouds.length > 0) {
    return settingsEx.clouds;
  }
  return predefinedClouds;
}
function getDefaultAzureCloud() {
  return config.azure.cloud || "AzureCloud" /* Public */;
}
function resolveLegacyCloudName(cloudName) {
  if (!cloudName) {
    return void 0;
  }
  switch (cloudName) {
    case "azuremonitor":
      return "AzureCloud" /* Public */;
    case "chinaazuremonitor":
      return "AzureChinaCloud" /* China */;
    case "govazuremonitor":
      return "AzureUSGovernment" /* USGovernment */;
    default:
      throw new Error(`Azure cloud '${cloudName}' is not recognized by datasource.`);
  }
}

export { AzureCloud, getAzureClouds, getDefaultAzureCloud, resolveLegacyCloudName };
//# sourceMappingURL=clouds.js.map
